<script setup lang="ts">
import type { SubmitEventPromise } from 'vuetify';

import { reactive, ref } from 'vue';
import { watchDebounced } from '@vueuse/core';
import _isEqual from 'lodash/isEqual';

import KBtn from '@/components/btns/KBtn.vue';
import KTextField from '@/components/fields/KTextField.vue';
import useForm from '@/composables/useForm';

export interface InitialData {
  search?: string | null;
}

export interface ValidData {
  search?: string | null;
}

export interface Props {
  loading?: boolean;
  initialData?: InitialData;
}
const props = withDefaults(defineProps<Props>(), {
  loading: false,
  initialData: () => ({}),
});
const emit = defineEmits<{
  submit: [event: SubmitEventPromise | null | undefined, formData: ValidData];
}>();

const formData = reactive<InitialData>({});
const isValid = ref(true);

const { form, handleSubmit } = useForm(props, formData, function (event) {
  const validData: ValidData = {
    search: formData.search,
  };
  emit('submit', event, validData);
});

watchDebounced(
  [() => formData.search],
  async (newValues, oldValues) => {
    if (_isEqual(newValues, oldValues)) return;
    await handleSubmit();
  },
  { debounce: 100 },
);
</script>

<template>
  <v-form
    ref="form"
    v-model="isValid"
    validate-on="lazy"
    :class="$style.chatRosterSideBarForm"
    data-testid="chatRosterSideBarForm"
    @submit.prevent="handleSubmit"
  >
    <KTextField
      v-model="formData.search"
      size="lg"
      clearable
      label="Search"
      :disabled="props.loading"
      :class="$style.field"
      hide-details
    />
    <KBtn
      type="submit"
      size="lg"
      priority="info"
      icon="mdi-magnify"
      :loading="props.loading"
      :class="$style.submit"
    />
  </v-form>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.chatRosterSideBarForm {
  display: flex;
}
  .field {
    width: 100%;
    margin-right: 12px;
  }
  .submit {
  }
</style>
